import { wordpressImgToImgixURL } from 'Utilities';

import ResponsiveImage from '../../../../../components/misc/ResponsiveImage/ResponsiveImage';

import styles from './ContentImage.scss';

type ContentImageProp = {
  imgAlt?: string;
  imgSrc: string;
  isStaticImageSize?: boolean;
}

export const ContentImage = (prop: ContentImageProp) => (
  <div className={styles.imageContainer}>
    <ResponsiveImage
      imgProps={{
        alt: prop?.imgAlt,
        height: 440,
        loading: 'lazy',
        width: 440,
      }}
      imgSrc={prop?.imgSrc ? wordpressImgToImgixURL(prop.imgSrc) : null}
      isStaticScreenSize={prop?.isStaticImageSize}
    />
  </div>
);
